<template>
    <SimpleDataCard
        :title="'Toplam Borç Tutarı'"
        :data="numberConverter(reportCompanyData.totalCurrentCredit,'TRY')"
        :description="'Tüm Zamanlar'"
        :loading="reportCompanyDataLoading"
    >

    </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamBorcTutari",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>